import { DangerAlert } from "components/common/Alerts";
import { Breadcrumb, BreadcrumbLink } from "components/common/Breadcrumb";
import DataTable from "components/common/DataTable";
import DataTableApiResponse from "interfaces/DataTableApiResponse";
import JobSummary from "interfaces/JobSummary";
import * as moment from "moment";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";
import getBaseUrl from "utils/getBaseUrl";
import ContentLoading from "components/common/ContentLoading";
import "./Index.css";
import apifetch from "utils/apifetch";
import extractErrorMessage from "utils/extractErrorMessage";

interface State {
    data: JobSummary[];
    spinner: boolean;
    errorMessage?: string;
}

export default class IndexBqs extends React.Component<
    RouteComponentProps<{}>,
    State
> {
    private baseUrl: string;
    private mainDataTableRef: React.RefObject<DataTable>;
    private dataTableRef: React.RefObject<HTMLTableElement>;

    constructor(props: RouteComponentProps<{}>) {
        super(props);

        this.state = {
            data: [],
            spinner: true,
            errorMessage: undefined,
        };

        this.baseUrl = getBaseUrl();
        this.mainDataTableRef = React.createRef();
        this.dataTableRef = React.createRef();

        this.dataTableData = this.dataTableData.bind(this);
        this.dataTableDataFilter = this.dataTableDataFilter.bind(this);
        this.handleDataTableDraw = this.handleDataTableDraw.bind(this);
    }

    public render() {
        return (
            <div className="container">
                <div className="animated fadeIn">
                    <Breadcrumb>
                        <BreadcrumbLink to="/">Home</BreadcrumbLink>
                        <BreadcrumbLink isActive={true}>Projects</BreadcrumbLink>
                    </Breadcrumb>
                    {this.state.errorMessage && (
                        <DangerAlert name="dangerAlert">{this.state.errorMessage}</DangerAlert>
                    )}
                    <div className="button-group">
                        <Link to="/jobs/add" className="button__item"><i className="icon-jobs"></i>Add Project</Link>
                    </div>
                    <div className="card card--datatables">
                        <div className="card-block">
                            <h2 className="card__title">BQS Projects</h2>
                            <div className="datatable-wrapper">
                                <DataTable
                                    ajaxUrl={this.baseUrl + "api/jobs/0/summary"}
                                    useAuth={true}
                                    ajaxData={this.dataTableData}
                                    ajaxDataFilter={this.dataTableDataFilter}
                                    onDraw={this.handleDataTableDraw}
                                    order={[[0, "desc"]]}
                                    ref={this.mainDataTableRef}
                                    stateSave={true}
                                >
                                    <thead>
                                        <tr>
                                            <th style={{ width: "15%" }}>ID</th>
                                            <th style={{ width: "10%" }}>Bid Date</th>
                                            <th style={{ width: "30%" }}>Project Name</th>
                                            <th style={{ width: "15%" }}>Type</th>
                                            <th style={{ width: "15%" }}>CIS #</th>
                                            <th style={{ width: "15%" }}>Salesperson</th>
                                            <th className="arrow-hidden"></th>
                                        </tr>
                                    </thead>
                                    <tbody></tbody>
                                </DataTable>
                                {this.state.spinner ? (
                                    <ContentLoading />
                                ) : (
                                    <table className="d-none" ref={this.dataTableRef}>
                                        <tbody>
                                            {this.state.data.map((item, index) => (
                                                <tr key={item.id}>
                                                    <td><Link to={"/jobs-bqs/" + item.id}>{item.id}</Link></td>
                                                    <td>
                                                        <Link to={"/jobs-bqs/" + item.id}>{item.bidDate && moment(item.bidDate).format("l")}</Link>
                                                    </td>
                                                    <td>
                                                        <Link to={"/jobs-bqs/" + item.id}>{item.name}</Link>
                                                    </td>
                                                    <td><Link to={"/jobs-bqs/" + item.id}>{item.type}</Link></td>
                                                    <td><Link to={"/jobs-bqs/" + item.id}>{item.cisNumber}</Link></td>
                                                    <td><Link to={"/jobs-bqs/" + item.id}>{item.salesPerson}</Link></td>
                                                    <td>
                                                        <Link
                                                            to={"/jobs/edit/" + item.id}
                                                            className="btn-edit"
                                                        >
                                                            <i className="icon-edit1"></i>
                                                        </Link>
                                                        <a
                                                            className="btn-delete"
                                                            href="#"
                                                            data-id={item.id}
                                                        >
                                                            <i className="icon-delete1"></i>
                                                        </a>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public async componentDidMount() {
        document.title = "Projects - " + SITE_NAME;
    }

    private dataTableData(data: any) {
        let sortFields = [
            "id",
            "bidDate",
            "name",
            "type",
            "cisNumber",
            "salesPerson",
        ];

        let newData = {
            pageNumber: Math.floor(data.start / data.length) + 1,
            pageSize: data.length,
            sortField: sortFields[data.order[0].column],
            sortDirection: data.order[0].dir === "asc" ? 1 : 2,
            search: data.search.value,
            draw: data.draw,
        };

        return newData;
    }

    private dataTableDataFilter(data: string) {
        var json = JSON.parse(data) as DataTableApiResponse<JobSummary>;

        this.setState({
            data: json.items,
            spinner: false,
        });

        let tableData = [];
        let $tr = $(this.dataTableRef.current!).find("tr");
        for (let i = 0; i < $tr.length; i++) {
            let $td = $tr.eq(i).find("td");
            let rowData = [];
            for (let j = 0; j < $td.length; j++) {
                rowData.push($td.eq(j).clone(true, true).html());
            }
            tableData.push(rowData);
        }

        let newData = {
            draw: json.draw,
            recordTotal: json.metadata.totalItemCount,
            recordsFiltered: json.metadata.totalItemCount,
            data: tableData,
        };

        return JSON.stringify(newData);
    }

    private handleDataTableDraw(dataTable: any) {
        $(dataTable)
            .find("a:not([href='#'])")
            .click((e) => {
                e.preventDefault();
                this.props.history.push($(e.currentTarget).attr("href")!);
            });

        $(dataTable)
            .find(".btn-delete")
            .click((e) => {
                e.preventDefault();

                const id = parseInt($(e.currentTarget).attr("data-id")!, 10);

                const confirmDelete = window.confirm("Are you sure you want to delete this project?");
                if (confirmDelete) {
                    this.deleteProject(id);
                }
            });
    }

    private async deleteProject(id: number) {
        this.setState({ errorMessage: undefined });
        let response = await apifetch(
            `jobs/${id}`,
            {
                method: "DELETE",
            },
            true
        );
        if (response.ok) {
            this.mainDataTableRef.current!.reload();
        } else {
            const errorText = await extractErrorMessage(response);
            this.setState({ errorMessage: errorText });
        }
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/Projects/Index-BQS.tsx